import { render, staticRenderFns } from "./Vacunas.vue?vue&type=template&id=51f607c3&scoped=true"
import script from "./Vacunas.vue?vue&type=script&lang=js"
export * from "./Vacunas.vue?vue&type=script&lang=js"
import style0 from "./Vacunas.vue?vue&type=style&index=0&id=51f607c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f607c3",
  null
  
)

export default component.exports